import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import './TestModeModal.css';

function TestModeModal({ storageKey = 'testModeModalSeen' }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Проверяем, было ли уже показано сообщение
    const hasSeen = localStorage.getItem(storageKey);
    if (!hasSeen) {
      setIsVisible(true);
    }
  }, [storageKey]);

  const handleClose = () => {
    localStorage.setItem(storageKey, 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="test-mode-modal-overlay" onClick={handleClose}>
      <div className="test-mode-modal" onClick={(e) => e.stopPropagation()}>
        <button className="test-mode-modal-close" onClick={handleClose} aria-label="Закрыть">
          <X size={20} />
        </button>
        <div className="test-mode-modal-content">
          <div className="test-mode-modal-icon">
            <span style={{ fontSize: '32px' }}>🐣</span>
          </div>
          <h3>Платформа находится в тестовом режиме</h3>
          <p>Возможны непредвиденные ошибки</p>
          <button className="test-mode-modal-button" onClick={handleClose}>
            Хорошо
          </button>
        </div>
      </div>
    </div>
  );
}

export default TestModeModal;
